export const isValidUsername = (str: string) => ['admin', 'editor'].indexOf(str.trim()) >= 0

export const isExternal = (path: string) => /^(https?:|mailto:|tel:)/.test(path)

// 根据url中参数名获取值
// ?search=%E9%9E%8B&price=1&num=2 参数
// 参数名 = search  参数值 = %E9%9E%8B
// 参数名 = price  参数值 = 1
// 参数名 = num  参数值 = 2
export const getQueryString = (name: string) => {
  // console.log(location);
  // console.log(location.search);
  // 1. 获取整个url参数的值的字符串 去掉第一个字符串 按照&分割成一个数组
  let urlParams = location.search.substr(1).split('&')
  // var urlParams = location.search.substring(1,location.search.length);
  // console.log(urlParams);
  for (let i = 0; i < urlParams.length; i++) {
    // search=%E9%9E%8B  =前面参数名 以=分割 如果等号前面的和参数名一样 返回=号后面的参数的值
    if (name === urlParams[i].split('=')[0]) {
      // 返回当前参数的值 同时转码
      return decodeURI(urlParams[i].split('=')[1])
    }
  }
}
